"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardContribution = void 0;
/**
 * Base class to be extended by modules to provide contribution to the
 * dashboard. This is the main class to extend for applications to display
 * content on the dashboard.
 *
 * Implementations can provide as many contributions as desired, they will be
 * displayed in each layout locations for the specific active sections. The
 * widgets themselves have total liberty on their behavior. There is not yet
 * much API they can hook to
 *
 * @export
 * @abstract
 * @class DashboardContribution
 */
class DashboardContribution {
    constructor() {
        /**
         * Return all the layout contributions provided by this class.
         *
         * @memberof DashboardContribution
         */
        this.getLayoutContributions = () => {
            return [];
        };
    }
}
exports.DashboardContribution = DashboardContribution;
//# sourceMappingURL=DashboardContribution.js.map